












































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiButtonMulti extends Vue {
  @Prop()
  menuList: Bemob.ListItem[];
  
  @Prop()
  menuKeyOfSelectedItem: string;

  @Prop()
  mainButtonClick: ()=>any;

  @Prop()
  ignoreFirst: boolean;

  @Prop()
  planLimits: keyof BillingLimits;

  @Prop({default: true })
  displayText: boolean;

  @Prop()
  ignoreRest: boolean;

  @Prop({ default: 'default' })
  buttonStyle: string;

  @Prop()
  outline: string;

  @Prop()
  size: boolean;

  @Prop()
  icon: string;

  @Prop()
  menuProps: any;

  get firstItem() {
    return this.menuList && this.menuList.length 
      ? this.menuList[0]
      : null;
  }
  
  mainButtonClickHandle(){
    if(this.mainButtonClick){
      return this.mainButtonClick();
    }
    this.firstItem.click()
  }

  get restItems() {
    return this.menuList && this.menuList.length 
      ? this.ignoreFirst 
        ? this.menuList.slice(1)
        : this.menuList
      : null;
  }

  get isRestDisabled() {
    return this.restItems
      ? this.restItems.every((item) => item.disabled)
      : true;
  }

  get stylesWithBorder() {
    return [ 'accent', 'red' ];
  }

  get outlineStyles() {
    return [ 'outline-accent', 'outline-alt' ]
  }

  get hasBorder() {
    return this.stylesWithBorder.includes(this.buttonStyle);
  }

  get isOutline() {
    return this.outlineStyles.includes(this.buttonStyle);
  }
}
